export const GENERAL_TABLE_OTHERS_INFO_REQUEST = 'GENERAL_TABLE_OTHERS_INFO_REQUEST';
export const GENERAL_TABLE_OTHERS_INFO_SUCCESS = 'GENERAL_TABLE_OTHERS_INFO_SUCCESS';
export const GENERAL_TABLE_OTHERS_INFO_FAIL = 'GENERAL_TABLE_OTHERS_INFO_FAIL';